"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _init = _interopRequireDefault(require("./init"));
var _listener = _interopRequireDefault(require("./listener"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function algolia(appId, apiKey) {
  return {
    init: (0, _init.default)(appId, apiKey),
    listener: _listener.default
  };
}
var _default = algolia;
exports.default = _default;